import { useLocalization, IconSearch, cn } from '@magicdoorinc/ui';
import { Show } from 'solid-js';
import IconClose from '~/assets/images/common/close.svg?component-solid';
import IconMagicStar from '~/assets/images/common/star.svg?component-solid';
import { useIsMobileWidth } from '~/hooks/useIsMobileWidth';
interface MagicSearchInputProps {
  dropdownVisible: () => boolean;
  /** Icon-only circle state, sized to match the nav buttons beside it. */
  collapsed?: boolean;
  searchTerm: string;
  handleSearchChange: (e: InputEvent) => void;
  handleKeyDown: (e: KeyboardEvent, ref: HTMLInputElement) => void;
  handleFocus: () => void;
  handleClear: () => void;
  isLoading?: boolean;
}

export const MagicSearchInput = (props: MagicSearchInputProps) => {
  const { t } = useLocalization();
  const isMobileWidth = useIsMobileWidth();
  let inputRef!: HTMLInputElement;

  const handleBlur = (e: FocusEvent) => {
    const target = e.currentTarget as HTMLElement;
    target.blur();
  };

  return (
    <form>
      <div class="absolute inset-0 rounded-full bg-primary" />
      <div class="relative p-px">
        <div
          class={cn(
            'absolute top-1/2 z-10 -translate-y-1/2',
            props.collapsed ? 'left-0 flex w-full justify-center' : 'left-[6px] bg-white lg:left-4'
          )}>
          <IconSearch class={cn('text-text-03', props.collapsed ? 'size-4' : 'ml-1 size-5')} onClick={props.handleFocus} />
        </div>

        <input
          ref={inputRef}
          type="text"
          class={cn(
            'w-full rounded-full px-3 py-1.5 text-primary focus:outline-none lg:pl-12',
            isMobileWidth() && 'pl-10',
            props.dropdownVisible() && 'pr-14',
            props.collapsed && 'h-9 px-0 lg:pl-0'
          )}
          value={props.searchTerm}
          onInput={(e) => props.handleSearchChange(e)}
          onKeyDown={(e) => props.handleKeyDown(e, inputRef)}
          onFocus={() => props.handleFocus()}
          onBlur={handleBlur}
          placeholder={props.collapsed ? '' : t('Magic search...')}
        />
        <Show when={!props.dropdownVisible()}>
          <IconMagicStar class="absolute right-4 top-1/2 z-10 hidden -translate-y-1/2 lg:block" />
        </Show>
        <Show when={props.searchTerm && props.dropdownVisible()}>
          <div class="absolute right-2 top-1/2 z-10 -translate-y-1/2">
            <button type="button" onClick={() => props.handleClear()} class="rounded-full border border-border p-1 focus:outline-none">
              <IconClose class="size-5 text-text-03" />
            </button>
          </div>
        </Show>
      </div>
    </form>
  );
};
